import { Box, Typography, Button, Collapse, Skeleton } from "@mui/material";
import skillsImg from "../../../assets/images/Entity/Skills.png";
import { colors } from "../../../theme/palette";
import { useState } from "react";
import SkillMeter from "./SkillMeter";
import { EndorsedSkill } from "../../../types";
import { useTranslation } from "react-i18next";

const EntityEndorsedSkills = ({
  skills,
  endorsementNumber,
  isLoading,
}: {
  skills: EndorsedSkill[];
  endorsementNumber: number;
  isLoading: boolean;
}) => {
  const [expanded, setExpanded] = useState(false);

  const initialSkills = skills.slice(0, 4);
  const remainingSkills = skills.slice(4);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const { t } = useTranslation();

  if (isLoading) return <></>;

  return (
    <Box
      sx={{
        backgroundColor: colors.White,
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        overflow: "hidden",
        display: "flex",
        justifyContent: "space-between",
        columnGap: "27px",
      }}
    >
      <Box
        sx={{
          padding: "29px 17px",
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "28px",
          }}
        >
          <Typography variant="body16ExtraBold" sx={{ display: "block", fontWeight: 700 }}>
            {t("pages.entity.topEndorsedSkills")}
          </Typography>
          <Typography
            variant="body14Regular"
            sx={{
              color: colors.Dark800,
            }}
          >
            {t("pages.entity.reviewedBy")}
            {` ${endorsementNumber}`}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            rowGap: "8px",
          }}
        >
          {initialSkills.map((skill, index) => (
            <SkillMeter key={index} skill={skill} />
          ))}
          {remainingSkills.length > 0 && (
            <>
              <Collapse in={expanded}>
                {remainingSkills.map((skill, index) => (
                  <SkillMeter key={index + 4} skill={skill} />
                ))}
              </Collapse>
              <Button
                variant="text-sm"
                fullWidth
                onClick={handleExpandClick}
                sx={{ marginTop: "17px", borderRadius: "4px" }}
              >
                {expanded ? t("pages.entity.seeLess") : t("pages.entity.seeMore")}
              </Button>
            </>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          margin: 0,
          display: {
            xs: "none",
            md: "block",
          },
        }}
      >
        <img
          style={{
            height: "100%",
            objectFit: "cover",
            opacity: "0.2",
          }}
          src={skillsImg}
          alt="Skills"
        />
      </Box>
    </Box>
  );
};

export default EntityEndorsedSkills;
